<template>
    <a-drawer title="搜索条件"
              :width="windowWidth >= 800 ? 800 : '95%'"
              :visible="visible"
              :bodyStyle="{padding: 0, background: '#f7f7f7'}"
              :zIndex="zIndex"
              placement="right"
              @close="close">

        <template #extra>
            <a-button type="primary"
                      html-type="submit"
                      @click="submit">搜索</a-button>
        </template>

        <a-spin :spinning="loadings">
            <a-form name="filter"
                    ref="form"
                    layout="vertical"
                    class="n-p-4 n-bg-1"
                    :model="filterForm">

                <a-row class="n-col-1"
                       wrap
                       :gutter="10">
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="任务标题"
                                     name="title">
                            <a-input v-model:value="filterForm.title"
                                     placeholder="请输入任务标题"
                                     show-count
                                     :maxlength="255" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="任务标签"
                                     name="tag">
                            <a-select v-model:value="filterForm.tag"
                                      mode="tags"
                                      placeholder="请选择任务标签"
                                      :options="tagOptions"
                                      @change="tagChange">

                                <template #option="{ label, color,value }">
                                    <div class="n-flex n-flex-a-c n-flex-a-c n-flex-j-sb">
                                        <div class="n-flex n-flex-a-c n-flex-a-c">
                                            <span class="c-tag n-mr-2"
                                                  :style="{background: color}"></span>
                                            <span>{{label}}</span>
                                        </div>
                                    </div>
                                </template>

                                <template #tagRender="{ value, label, closable, onClose }">
                                    <a-tag :closable="closable"
                                           class="n-flex n-flex-a-c"
                                           @close="onClose">
                                        {{ label }}
                                        <i class="c-tag c-tag-small n-ml-1"
                                           :style="{background: tagOptions.filter(item => item.value == value)[0] ? tagOptions.filter(item => item.value == value)[0].color : ''}"></i>
                                    </a-tag>
                                </template>
                            </a-select>

                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="负责人（至少输入2个字符）"
                                     name="charge">
                            <a-select v-model:value="filterForm.charge"
                                      showSearch
                                      mode="multiple"
                                      placeholder="请选择负责人"
                                      notFoundContent="没有搜索到负责人"
                                      :filterOption="false"
                                      :options="chargeOptions"
                                      :loading="chargeLoading"
                                      @search="searchCharge"
                                      @change="chargeChange">
                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="执行人（至少输入2个字符）"
                                     name="executor">
                            <a-select v-model:value="filterForm.executor"
                                      showSearch
                                      mode="multiple"
                                      placeholder="请选择负责人"
                                      notFoundContent="没有搜索到负责人"
                                      :filterOption="false"
                                      :options="executorOptions"
                                      :loading="executorLoading"
                                      @search="searchExecutor"
                                      @change="executorChange">
                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="开始日期"
                                     name="start">
                            <a-date-picker value-format="YYYY-MM-DD"
                                           v-model:value="filterForm.start"
                                           class="n-col-1" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="截止日期"
                                     name="end">
                            <a-date-picker value-format="YYYY-MM-DD"
                                           v-model:value="filterForm.end"
                                           class="n-col-1" />
                        </a-form-item>
                    </a-col>

                    <a-col :sm="12"
                           :xs="24"
                           v-if="filterType == 'panel'">
                        <a-form-item label="仅查看某人的项目（至少输入2个字符）"
                                     name="charge">
                            <a-select v-model:value="filterForm.onlyLeader"
                                      showSearch
                                      mode="multiple"
                                      placeholder="请选择查看人员"
                                      notFoundContent="没有搜索到查看人员"
                                      :filterOption="false"
                                      :options="onlyLeaderOptions"
                                      :loading="onlyLeaderLoading"
                                      @search="searchOnlyLeader"
                                      @change="onlyLeaderChange">
                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-spin>
    </a-drawer>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';

    import nui from '@/assets/script';

    export default {
        name: 'FilterTask',
        props: {
            visible: { type: Boolean, default: false },
            projectOptions: { type: Array, default: () => [] },
            projectValue: Number,
            zIndex: Number,
            filterType: String,
            defaultFilter: Object,
            value: { type: Object, default: () => { } }
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['windowWidth', 'level', 'status'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loadings: false,

                chargeLoading: false,
                onlyLeaderLoading: false,
                executorLoading: false,
                chargeOptions: [],
                onlyLeaderOptions: [],
                executorOptions: [],

                tagOptions: [],

                filterForm: {
                    title: '',
                    start: null,
                    end: null,
                    charge: [],
                    charges: [],
                    executor: [],
                    executors: [],
                    tag: [],
                    tags: [],
                    onlyLeader: [],
                    onlyLeaders: []
                }
            })
        },
        watch: {
            visible: function () {
                // 避免外部添加数据，每次打开都重新获取一下
                if (this.visible) {
                    this.filterForm = Object.assign({}, (this.defaultFilter || {}))
                    this.getData()
                }
            }
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {

            },
            /**
             * @description 获取添加需要的数据
             */
            getData () {
                this.loadings = true;

                this.request(this.API.tag, { method: 'post', params: { projectId: this.projectValue } }).then(res => {

                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.tagOptions = res.data.map(item => {
                            return {
                                value: item.id,
                                label: item.name,
                                color: item.colorCode,
                                ext: item
                            }
                        })
                    }

                    this.loadings = false;
                })
            },
            /**
             * @description 搜索负责人
             */
            searchCharge (data) {
                if (data.length < 2) {
                    return
                }

                this.searchUser(data, 'charge')
            },
            searchOnlyLeader (data) {
                if (data.length < 2) {
                    return
                }

                this.searchUser(data, 'onlyLeader')
            },
            /**
             * @description 搜索负责人
             */
            searchExecutor (data) {
                if (data.length < 2) {
                    return
                }

                this.searchUser(data, 'executor')
            },
            /**
             * @description 搜索用户
             */
            searchUser (data, type) {
                this[type + 'Loading'] = true;

                this.request(this.API.getUserListByAddition, {
                    params: {
                        username: data
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this[type + 'Options'] = res.data.map(item => {
                            return {
                                value: item.adName,
                                label: item.userName,
                                optionTitle: item.userName + ' ' + item.position,
                                ext: item,
                            }
                        })

                        this[type + 'Loading'] = false;
                    }
                })
            },
            /**
             * @description 缓存多选数据
             */
            chargeChange (data, options) {
                var data = options.filter(item => data.indexOf(item.value) >= 0);

                this.filterForm.charges = data.map(item => item.ext)
            },
            /**
             * @description 缓存多选数据
             */
            onlyLeaderChange (data, options) {
                var data = options.filter(item => data.indexOf(item.value) >= 0);

                this.filterForm.onlyLeaders = data.map(item => item.ext)
            },
            /**
             * @description 缓存多选数据
             */
            executorChange (data, options) {
                var data = options.filter(item => data.indexOf(item.value) >= 0);

                this.filterForm.executors = data.map(item => item.ext)
            },

            /**
            * @description 缓存多选数据
            */
            tagChange (data, options) {
                var data = options.filter(item => data.indexOf(item.value) >= 0);
                this.filterForm.tags = data.map(item => item.ext)
            },

            close () {
                this.$emit('close')
            },
            submit () {
                this.$emit('change', this.filterForm)
                this.$emit('close')
            }
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss">
</style>
